export enum TenantSubscriptionEnum {
  PER_LOCATION = 'PER_LOCATION',
  PER_TRANSACTION = 'PER_TRANSACTION',
  PER_BUNDLE = 'PER_BUNDLE',
  PER_USER = 'PER_USER',
  PER_BRANCH = 'PER_BRANCH',
  PER_BLOCK = 'PER_BLOCK',
}
